import { useHoaDonBanHangMutation } from './useHoaDonBanHangMutation';
import { useHoaDonBanHangImport } from './useHoaDonBanHangImport';
import { useHoaDonBanHangSearchContext } from './search-context';
import { useHoaDonBanHangTable } from './useHoaDonBanHangTable';
import { QUERY_KEYS } from '@/constants';
import { useCRUD } from '@/hooks';

const OPEN_RECORD_PARAM = 'erp-view-record';

export const useHoaDonBanHangPage = () => {
  const { isExporting, isImportDialogOpen, openImportDialog, closeImportDialog, transactionOptions } =
    useHoaDonBanHangSearchContext();
  const tableState = useHoaDonBanHangTable();
  const { deleteItem: deleteGiayBaoCo } = useCRUD({ endpoint: QUERY_KEYS.GIAY_BAO_CO, initialFetch: false });
  const { deleteItem: deletePhieuThu } = useCRUD({ endpoint: QUERY_KEYS.PHIEU_THU, initialFetch: false });
  const importState = useHoaDonBanHangImport({
    closeImportDialog,
    refreshData: tableState.crud.refreshData,
    transactionOptions
  });
  const mutationState = useHoaDonBanHangMutation({
    detail: tableState.crud.detail,
    formMode: tableState.form.formMode,
    addItem: tableState.crud.addItem,
    updateItem: tableState.crud.updateItem,
    deleteItem: tableState.crud.deleteItem,
    deleteGiayBaoCo,
    deletePhieuThu,
    handleCloseForm: tableState.form.handleCloseForm,
    handleCloseDelete: tableState.form.handleCloseDelete,
    clearSelection: tableState.selection.clearSelection,
    refreshData: tableState.crud.refreshData
  });
  const handleOpenInNewTab = (params: { row: BanHangRecord }) => {
    if (!params.row?.uuid) return;

    const targetUrl = new URL(window.location.href);
    targetUrl.searchParams.set(OPEN_RECORD_PARAM, params.row.uuid);
    window.open(targetUrl.toString(), '_blank', 'noopener,noreferrer');
  };

  return {
    searchDialog: tableState.searchDialog,
    importDialog: {
      open: isImportDialogOpen,
      isImporting: importState.isImporting,
      openDialog: () => tableState.form.handleImportExcel(openImportDialog),
      closeDialog: closeImportDialog,
      onSubmit: importState.handleImportFromExcel
    },
    importErrorDialog: importState.importErrorDialog,
    formDialog: {
      open: tableState.dialogs.showForm,
      formMode: tableState.form.formMode,
      isCopyMode: tableState.dialogs.isCopyMode,
      detail: tableState.crud.detail,
      isLoading: tableState.crud.isDetailLoading,
      onClose: tableState.form.handleCloseForm,
      onSubmit: mutationState.handleSubmit,
      onAdd: tableState.form.handleAddClick,
      onEdit: tableState.form.handleEditClick,
      onDelete: tableState.form.handleDeleteClick,
      onCopy: tableState.form.handleCopyClick
    },
    deleteDialog: {
      open: tableState.dialogs.showDelete,
      onClose: tableState.form.handleCloseDelete,
      onConfirm: mutationState.handleDelete
    },
    cantEditDialog: {
      open: tableState.dialogs.showCantEdit,
      onClose: tableState.form.handleCantEditClose
    },
    bulkDeleteDialog: {
      open: tableState.dialogs.showBulkDelete,
      onClose: tableState.form.handleCloseBulkDelete,
      onDelete: mutationState.handleBulkDelete
    },
    table: tableState.table,
    detailTable: {
      rows: tableState.selection.selectedObj ? tableState.crud.detailRowsWithStock : []
    },
    actions: {
      isExporting,
      handleAddClick: tableState.form.handleAddClick,
      handleEditClick: tableState.form.handleEditClick,
      handleDeleteClick: tableState.form.handleDeleteClick,
      handleCopyClick: tableState.form.handleCopyClick,
      handleViewClick: tableState.form.handleViewClick,
      handleOpenInNewTab,
      handleRowClick: tableState.form.handleRowClick,
      handleRefresh: tableState.table.onRefresh,
      handleSearch: tableState.searchDialog.onOpen
    },
    selection: {
      selectedObj: tableState.selection.selectedObj,
      selectedRowIndex: tableState.selection.selectedRowIndex
    }
  };
};
